import React from "react";
import QuantityPicker from "../../Offers/QuantityPicker/QuantityPicker";
import "./CartQuantityPicker.css";
import { useCart } from "../../../context/CartContext";

const CartQuantityPicker = ({ item }) => {
  const { increment, decrementOrRemove } = useCart();
  const value = item.quantity || 1;
  const itemId = item.internal_package_id || item.id;
  const isTopUp = item.type === "topup" || item.is_topup;

  const handleChange = (next) => {
    if (next > value) {
      if (isTopUp) {
        alert("Only 1 top-up can be purchased at a time.");
        return;
      }

      increment(item);
    } else if (next < value) {
      decrementOrRemove(itemId);
    }
  };

  return (
    <div className="cart-quantity-picker">
      <QuantityPicker value={value} onChange={handleChange} min={0} max={99} />
    </div>
  );
};

export default CartQuantityPicker;
